<template>
	<div class="main">
		<div class="row">
			<div class="col-md-4">
				<router-link v-bind:to="'/services/' + idService + '/requests/' + idRequest + '/logs'" class="btn btn-info">{{ $t('Back') }}</router-link>
			</div>
			<div class="col-md-4 text-center">
				<h3>{{ $t('Logs') }}</h3>
			</div>
		</div>
		<hr />
		<h5>{{ $t('Date') }}</h5>
		{{ formatDate(log.date) }}
		<h5>{{ $t('Message') }}</h5>
		{{ log.message }}
		<div v-if="log.data">
			<h5>{{ $t('Details') }}</h5>
			<pre>{{ log.data }}</pre>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
	props: {
		requestsService: {
			type: Object,
		},
	},
	data() {
		return {
			log: {},
		};
	},
	methods: {
		formatDate(value) {
			return moment(value).format("DD/MM/YYYY HH:mm:ss");
		},
		formatJSON(value) {
			return JSON.stringify(JSON.parse(value), undefined, "   ");
		},
	},
	async created() {
		this.idService = this.$route.params.idService;
		this.idRequest = this.$route.params.idRequest;
		this.idRequestLog = this.$route.params.idRequestLog;
		this.log = await this.requestsService.getLog(this.idService, this.idRequest, this.idRequestLog);
	}
};
</script>

<style>
.main {
	padding: 30px;
}
.text-right {
	text-align: right;
}
pre {
	background-color: transparent !important;
	border: 0 !important;
	white-space: pre-wrap;
	word-wrap: break-word;
}
.request {
	height: 100px !important;
}
</style>
